import { LabRequisitions, throwOnError, useAuth } from 'prove-common'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useAnalysisCompletedMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (requisitionId: number) => {
      const { data, error } = await authFetch().POST(
        '/requisitions/{requisitionId}/analysis-completed',
        {
          params: {
            path: {
              requisitionId
            }
          }
        }
      )
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: (data, requisitionId) => {
      queryClient.setQueryData(['requisitions'], (oldData: LabRequisitions) => {
        if (oldData != null) {
          return oldData.map((requisition) => {
            if (requisition.id === requisitionId) {
              return {
                ...requisition,
                status: 'ReadyToProcess'
              }
            }
            return requisition
          })
        }
        return oldData
      })
    }
  })
}
